module.exports = __webpack_public_path__ + "img/svg - only cam.f57e6b87.svg";